import React from "react";
import { useGetNflAllTimeGreatsLeadersQuery } from "../../store/api/nflApi";
import {
  getNflDisplayName,
  NFL_COMPARE_PRESETS,
} from "../../adapters/nflPlayerAdapter";
import { CompareInspirationHost } from "../compare/CompareInspiration";
import { getNflCompareInspirationSections } from "../compare/compareInspirationCatalog";

const NFL_INSPIRATION_SECTIONS = getNflCompareInspirationSections();

const nflDisplayName = (row, player) => getNflDisplayName(row, player.name);

const NflCompareInspiration = ({ selectedIds, onSelect, onSelectMatchup }) => (
  <CompareInspirationHost
    sections={NFL_INSPIRATION_SECTIONS}
    selectedIds={selectedIds}
    onSelect={onSelect}
    matchups={NFL_COMPARE_PRESETS}
    onSelectMatchup={onSelectMatchup}
    sport="nfl"
    getName={nflDisplayName}
    useLeadersQuery={useGetNflAllTimeGreatsLeadersQuery}
  />
);

export default NflCompareInspiration;
